import { Component, OnInit } from "@angular/core";

import { GlobalCfgService } from "../../services/globalcfg.service";
import { SubscriptionService } from "../../services/subscription.service";

import { MatDialog } from '@angular/material/dialog';

import { ViewPlansComponent } from './viewplans/view-plans.component';

@Component({
  selector: "rm-manage-billing",
  templateUrl: "./manage-billing.component.html",
  styleUrls: ["./manage-billing.component.css"]
})
export class ManageBillingComponent implements OnInit {

  currentPlanObj: any;

  constructor(
    private dialog: MatDialog,
    private globalCfgService: GlobalCfgService,
    private subscriptionService: SubscriptionService
  ) { }

  ngOnInit() {
    console.log('calling getOrgSubscriptionDetails in manage billing');
    this.getOrgSubscriptionDetails();
  }

  getOrgSubscriptionDetails() {
    const filter = { "where": { "gcp": this.globalCfgService.getGcp() } };
    this.subscriptionService.getCurrentPlanOfOrg(filter).subscribe((response: any) => {
      if (response.count === 1) {
        this.currentPlanObj = response.data[0];
        this.getOrgPricePlanDetails(this.currentPlanObj.pricePlanId);
      }
    });
  }

  getOrgPricePlanDetails(planId) {
    this.subscriptionService.getPricePlanDetails(planId).subscribe((res: any) => {
      this.currentPlanObj.planDetail = res;
      if (this.currentPlanObj.planDetail.name === 'Small') {
        this.currentPlanObj.planDetail.displayName = 'Basic';
      } else if (this.currentPlanObj.planDetail.name === 'Medium') {
        this.currentPlanObj.planDetail.displayName = 'Intermediate';
      } else if (this.currentPlanObj.planDetail.name === 'Large') {
        this.currentPlanObj.planDetail.displayName = 'Pro';
      } else {
        this.currentPlanObj.planDetail.displayName = 'Free';
      }
    });
  }

  viewPlanDetails(planObj) {
    // call method to get plan details pdf
  }

  openPlansDialog() {
    this.dialog.open(ViewPlansComponent, {
      width: "650px",
      data: {
        title: "Plans"
      },
    });
  }
}
